import { Component, OnInit, HostBinding, Output, EventEmitter, Input, ViewChild, TemplateRef, Injector, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { DatagridComponent } from '@farris/ui-datagrid';
import { MessagerService } from '@farris/ui-messager';
import { ProcessDeUtil } from '../../domain/process-de-util';
import { EventDefinition } from './event-definition.entity';
import { EditorTypes } from '@farris/ui-datagrid-editors';
import { TypeConverter } from '@farris/ide-property-panel';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-event-definition',
  templateUrl: './event-definition.component.html',
  styleUrls: ['./event-definition.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class EventDefinitionComponent implements OnInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input()
  set value(items: any[]) {
    if (items && items.length > 0) {
      for (const item of items) {
        const event = new EventDefinition();
        event.Id = item.Id;
        event.name = item.name;
        event.triggerAction = item.triggerAction;
        event.Async = item.Async;
        event.SignalRef = item.SignalRef;
        this.data.push(event);
      }
    }
  }
  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  @ViewChild('grid') grid: DatagridComponent;

  modalConfig = {
    title: this.localePipe.transform('component.eventDefinition.eventDefinition'),
    width: 560,
    height: 420,
    showButtons: true
  };

  triggerActionCollection: any[] = [
    { text: this.localePipe.transform('component.eventDefinition.pass'), value: 'Pass' },
    { text: this.localePipe.transform('component.eventDefinition.back'), value: 'Back' },
    { text: this.localePipe.transform('component.eventDefinition.abort'), value: 'Abort' }];

  columns = new Array();
  data = new Array<EventDefinition>();

  constructor(
    private message: MessagerService,
    private util: ProcessDeUtil,
    private injector: Injector,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
    this.columns = [{
      field: 'SignalRef', width: 100, title: this.localePipe.transform('component.eventDefinition.signalRef'),
      editor: { type: EditorTypes.TEXTBOX, options: {} },
      validators: [
        { type: 'required', messager: '必填' }
      ]
    },
    {
      field: 'name', width: 100, title: this.localePipe.transform('component.eventDefinition.name'),
      editor: { type: EditorTypes.TEXTBOX, options: {} },
      validators: [
        { type: 'required', messager: '必填' }
      ]
    },
    {
      field: 'triggerAction', width: 100, title: this.localePipe.transform('component.eventDefinition.triggerAction'),
      formatter: {
        type: 'enum',
        options: { valueField: 'value', textField: 'text', data: this.triggerActionCollection }
      },
      editor: {
        type: EditorTypes.COMBOLIST,
        options: { valueField: 'value', textField: 'text', data: this.triggerActionCollection, idField: 'value', panelHeight: 'auto', showClear: false }
      },
      validators: [
        { type: 'required', messager: '必填' }
      ]
    }];
  }
  add() {
    const event = new EventDefinition();
    event.Id = ProcessDeUtil.GenerateElementId();
    this.data.push(event);
    this.grid.loadData(this.data);
  }
  delete() {
    this.grid.endCellEdit();
    if (this.grid.selectedRow && this.grid.selectedRow.data) {
      const i = this.data.findIndex(d => d.Id === this.grid.selectedRow.data.Id);
      this.data.splice(i, 1);
      this.grid.loadData(this.data);
    } else {
      this.message.info(this.localePipe.transform('component.eventDefinition.selectedRow'));
    }
  }

  clickOK() {
    this.grid.endCellEdit();
    if (this.validator()) {
      const object = { value: this.data, parameters: null };
      this.submitModal.emit(object);
    }

  }

  clickCancel() {
    this.closeModal.emit();
  }

  private validator(): boolean {
    if (this.data.length === 0) {
      this.message.info(this.localePipe.transform('component.eventDefinition.dataLength'));
      return false;
    } else {
      for (const d of this.data) {
        if (!d.SignalRef) {
          this.message.info(this.localePipe.transform('component.eventDefinition.codeNotNull'));
          return false;
        } else if (!d.name) {
          this.message.info(this.localePipe.transform('component.eventDefinition.nameNotNull'));
          return false;
        } else if (!isNaN(Number(d.SignalRef))) {
          this.message.info(this.localePipe.transform('component.eventDefinition.codeNotNumber'));
          return false;
        }
      }
      if (this.data.length > 1) {
        for (let i = 0; i < this.data.length; i++) {
          const code1 = this.data[i].SignalRef;
          for (let j = i + 1; j < this.data.length; j++) {
            const code2 = this.data[j].SignalRef;

            if (code1 === code2) {
              this.message.warning(this.localePipe.transform('component.eventDefinition.codeRepeat'));
              return false;
            }
          }
        }
      }
    }
    return true;
  }
}

export class EventDefinitionConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any[]): string {
    if (data && data.length > 0) {
      return this.localePipe.transform('component.eventDefinition.set');
    } else {
      return this.localePipe.transform('component.eventDefinition.notSet');
    }
  }
}
